import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Controller, { inject as controller } from '@ember/controller';
import actionInfo from 'cio/utils/action-info';
import { Periods } from 'cio/utils/metrics/common';
import { Grouping } from 'cio/utils/metrics/resolution';
import { tracked } from '@glimmer/tracking';

const QUERY_PARAM_DEFAULT_VALUE_RESOLUTION = Periods.DAYS;
const QUERY_PARAM_DEFAULT_VALUE_GROUPING = Grouping.Daily;

export default class DashboardController extends Controller {
  @controller authenticated;

  @service eventBus;
  @service store;

  queryParams = [
    {
      startTimeQP: { as: 'start_time' },
      endTimeQP: { as: 'end_time' },
      resolutionQP: { as: 'resolution' },
      groupingQP: { as: 'grouping' },
    },
  ];

  // initialize query params with "null" and then handle default values using
  // setters/getters to avoid empty values being added to the URL
  // ("?start_time=&end_time=&resolution=&grouping=")
  @tracked startTimeQP = null;
  @tracked endTimeQP = null;
  @tracked resolutionQP = null;
  @tracked groupingQP = null;

  get startTime() {
    return this.startTimeQP ?? '';
  }
  set startTime(value) {
    this.startTimeQP = value === '' ? null : value;
  }
  get endTime() {
    return this.endTimeQP ?? '';
  }
  set endTime(value) {
    this.endTimeQP = value === '' ? null : value;
  }
  get resolution() {
    return this.resolutionQP ?? QUERY_PARAM_DEFAULT_VALUE_RESOLUTION;
  }
  set resolution(value) {
    this.resolutionQP = value === QUERY_PARAM_DEFAULT_VALUE_RESOLUTION ? null : value;
  }
  get grouping() {
    return this.groupingQP ?? QUERY_PARAM_DEFAULT_VALUE_GROUPING;
  }
  set grouping(value) {
    this.groupingQP = value === QUERY_PARAM_DEFAULT_VALUE_GROUPING ? null : value;
  }

  emailActionInfo = actionInfo('email_action');

  showUsageWarning = null;

  @readOnly('authenticated.account') account;

  transitionMetaData = null;
  renderedAtTimestamp = 0;

  @action
  setTransitionMetaData(data) {
    if (this.transitionMetaData) {
      this.set('transitionMetaData', data);
    } else {
      this.set('transitionMetaData', { ...this.transitionMetaData, ...data });
    }
  }

  @action
  resetQueryParams() {
    this.setProperties({
      startTime: '',
      endTime: '',
      resolution: Periods.DAYS,
      grouping: Grouping.Daily,
    });
  }

  @action
  onTimeRangeChange(startTime, endTime) {
    this.setProperties({ startTime, endTime });
  }
}
